<template>
    <v-treeview v-bind="$attrs" :class="{ 'vuex-treeview--no-hover': disableHover }">
        <template v-for="(_, name) in $slots" v-slot:[name]="slotProps">
            <slot :name="name" v-bind="slotProps || {}" />
        </template>
    </v-treeview>
</template>

<script>
export default {
    name: 'VuexTreeview',

    inheritAttrs: false,

    props: {
        /**
         * When true, disables the hover background highlight on treeview items.
         */
        disableHover: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped lang="scss">
.vuex-treeview--no-hover {
    :deep(.v-list-item::before),
    :deep(.v-list-item::after) {
        display: none;
    }

    :deep(.v-list-item:hover > .v-list-item__overlay) {
        opacity: 0;
    }

    :deep(.v-list-item) {
        cursor: default;
    }
}
</style>
